module.exports = __webpack_public_path__ + "img/checkmark_dark.a21712ab.svg";